module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAbFBMVEUAAAD0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz+rC3eAAAAI3RSTlMA8Tf31eoqrJNbRfm0dGVWGQ8G3b05FczJpaCfjIeEaSMcDipxTKUAAACySURBVCjPfdLZEoMgDIXhQwVx36rd97z/O7bTEVSM+W+/IcwEALRW6R22ak9EpDbdEgk+EEl+JdH35D1mOCJfwjDJPJ2OuOHaawami6hIR9Ydy50Z/Qm2x8iqYfnjjhcQb6eSd+s8Zbl1e89r1mMVzH/db/MVZrnz4gBgp4L3Tadnrf4aeEU+/VPJ2f9TR7IPZuUas5o+5ByLyuCCHsve58XsZr3BRM1WxNTVydFExmYAvgGoKk84VQK3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_bottom_tel1.png
// module id = s8gp
// module chunks = 1